import { render, staticRenderFns } from "./RetailerMarginItem.vue?vue&type=template&id=1dbc1e76&lang=pug"
import script from "./RetailerMarginItem.vue?vue&type=script&lang=js"
export * from "./RetailerMarginItem.vue?vue&type=script&lang=js"
import style0 from "./RetailerMarginItem.vue?vue&type=style&index=0&id=1dbc1e76&prod&lang=sass"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports